export default __webpack_public_path__ + "static/media/addUserGrey.4ac261d9.svg";